var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogMenu1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6889 17.9447C18.755 18.4014 18.8871 18.793 19.0853 19.2497C19.3495 19.7718 19.6799 20.2285 20.0762 20.4243C20.3405 20.62 20.6708 20.6853 21.0011 20.62C21.0011 20.5548 21.0672 20.5548 21.1333 20.5548C21.3975 20.4895 21.5957 20.2938 21.6618 20.098C21.8599 19.6739 22.0416 19.2661 22.2233 18.8582C22.405 18.4504 22.5866 18.0426 22.7848 17.6184C22.983 17.1943 23.1647 16.7864 23.3464 16.3786C23.528 15.9708 23.7097 15.5629 23.9079 15.1388C24.04 14.8778 24.04 14.5515 23.8419 14.2905C23.7097 14.0947 23.3794 13.899 23.0491 13.899C21.86 13.8337 20.6708 14.2252 19.878 14.943C18.7924 14.5856 17.7473 14.1882 16.6793 13.7821C16.3824 13.6693 16.0838 13.5557 15.7821 13.4422C16.2446 13.0507 16.707 12.6755 17.1694 12.3003C17.6319 11.9251 18.0943 11.5498 18.5568 11.1583C19.5477 10.3753 20.4726 9.59224 21.3975 8.8092C21.6618 8.54818 21.7939 8.15666 21.5957 7.76514C21.3314 7.30837 21.1333 6.91685 20.9351 6.46008C21.0672 6.39482 21.1993 6.32957 21.3975 6.26432C21.7278 6.19907 21.926 5.93805 21.9921 5.67704C22.0581 5.48128 21.9921 5.28552 21.926 5.08976C21.926 5.0245 21.8599 4.95925 21.7939 4.894C21.1973 4.21168 20.6007 3.49988 19.997 2.77961C19.3306 1.98447 18.6555 1.17901 17.9622 0.39152C17.764 0.19576 17.4998 0.0652533 17.2355 0H0.587528C0.557954 0.0194742 0.529851 0.0374955 0.502999 0.0547142C0.349905 0.152887 0.237495 0.224971 0.125084 0.39152C-0.00704296 0.652533 -0.0731064 0.9788 0.125084 1.30507C0.882232 2.64499 1.62432 3.98491 2.35853 5.31062C3.16181 6.76104 3.95567 8.19445 4.74952 9.59224C5.51127 10.9944 6.27301 12.3608 7.02525 13.7101C7.70826 14.9352 8.38343 16.1463 9.04365 17.3574C9.24184 17.6184 9.50609 17.8142 9.83641 17.8794C10.1667 17.9447 10.5631 17.8794 10.7613 17.6836C11.5541 17.0964 12.2808 16.5091 13.0075 15.8566C14.9233 16.5743 16.8391 17.2921 18.6889 17.9447Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05267 26.0361C3.75855 23.165 6.40108 18.3363 9.63819 19.4456C11.0645 19.9603 11.5684 21.2513 12.0671 22.5291C12.7695 24.3289 13.4617 26.1025 16.707 25.6446C16.707 25.7099 11.554 28.3853 8.05267 26.0361Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7549 24.9268C15.4518 25.1878 14.7911 21.7946 16.9052 21.0768C17.8178 20.749 18.5915 21.1874 19.3572 21.6212C20.417 22.2218 21.4614 22.8135 22.8375 21.3521C22.8205 21.377 22.79 21.4337 22.7459 21.5154C22.3725 22.2082 21.0281 24.7022 18.7549 24.9268Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8509 21.3378C22.8483 21.3378 22.8439 21.3427 22.8375 21.3521L22.8509 21.3378Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMenu1);
export default __webpack_public_path__ + "static/media/catalog-menu-1.3af77b49efbfd4687c77553d1ec7aada.svg";
export { ForwardRef as ReactComponent };